import { z } from 'zod';

import {
  galleryCategorySchema,
  galleryImageWireSchema,
  imageContentTypeSchema,
  imageRefWireSchema,
} from '../image';
import { ulidSchema } from '../primitives';

export const imageKindSchema = z.enum(['LOGO', 'COVER', 'GALLERY', 'MENU_ITEM']);
export type ImageKind = z.infer<typeof imageKindSchema>;

export const requestUploadUrlRequestSchema = z.object({
  kind: imageKindSchema,
  menuItemId: ulidSchema.optional(),
  contentType: imageContentTypeSchema,
});
export type RequestUploadUrlRequest = z.infer<typeof requestUploadUrlRequestSchema>;

export const requestUploadUrlResponseSchema = z.object({
  uploadUrl: z.string().url(),
  fields: z.record(z.string()),
  s3Key: z.string(),
  expiresAt: z.string(),
});
export type RequestUploadUrlResponse = z.infer<typeof requestUploadUrlResponseSchema>;

export const attachImageRequestSchema = z.object({
  kind: imageKindSchema,
  menuItemId: ulidSchema.optional(),
  s3Key: z.string().min(1),
  caption: z.string().max(280).optional(),
  sortOrder: z.number().int().nonnegative().optional(),
  category: galleryCategorySchema.optional(),
});
export type AttachImageRequest = z.infer<typeof attachImageRequestSchema>;

export const patchImageRequestSchema = z.object({
  caption: z.string().max(280).optional(),
  sortOrder: z.number().int().nonnegative().optional(),
  category: galleryCategorySchema.optional(),
});
export type PatchImageRequest = z.infer<typeof patchImageRequestSchema>;

/** Attach returns gallery wire for GALLERY kind, image ref wire for LOGO / COVER / MENU_ITEM. */
export const attachImageResponseSchema = z.union([galleryImageWireSchema, imageRefWireSchema]);
export type AttachImageResponse = z.infer<typeof attachImageResponseSchema>;

export const restaurantImagePathParamsSchema = z.object({
  id: ulidSchema,
  imageId: ulidSchema,
});
export type RestaurantImagePathParams = z.infer<typeof restaurantImagePathParamsSchema>;
